import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { ProviderDetails } from '@ratehub/base-ui';
import { RATEHUB_BROKERAGE_IDS } from '@ratehub/mtg-common';


function ProductTableProviderCell({ rate, isLogoWrapped, hasLogoBorder, ...otherProps }) {
    return (
        <ProviderCell {...otherProps}>
            <ProviderDetails
                providerIcon={rate?.provider?.logo}
                isRatehubCompany={Object.values(RATEHUB_BROKERAGE_IDS).includes(rate?.provider?.id)}
                providerName={rate?.provider?.name}
                isLogoWrapped={isLogoWrapped}
                hasLogoBorder={hasLogoBorder}
                className="provider-details"
            />
        </ProviderCell>
    );
}

const ProviderCell = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    > .provider-details {
        flex: 1;
    }
`;

ProductTableProviderCell.propTypes = {
    rate: PropTypes.object.isRequired,
    isLogoWrapped: PropTypes.bool,
    hasLogoBorder: PropTypes.bool,
};

ProductTableProviderCell.defaultProps = {
    isLogoWrapped: true,
    hasLogoBorder: false,
};

export default ProductTableProviderCell;
